const PercentageCard = ({ percentage, title, subtitle }) => {
  return (
    <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
      <h3 className="text-base font-semibold text-black mb-4">{title}</h3>
      
      <div className="text-5xl font-bold text-black mb-4">{percentage}</div>
      
      <div className="w-full bg-gray-200 rounded-full h-3 mb-3 overflow-hidden">
        <div
          className="h-full bg-blue-500 rounded-full transition-all duration-500"
          style={{ width: percentage }}
        />
      </div>
      
      <p className="text-sm text-gray-500">{subtitle}</p>
    </div>
  );
};

export default PercentageCard;
